import { Alert } from "@blueprintjs/core";
import * as React from "react";

class AlertModal extends React.PureComponent {

  state = {
    isOpen: true,
    themeName: localStorage.getItem("themeName"),
    cancelButtonText: this.props.cancelButtonText || 'Cancel',
    confirmButtonText: this.props.confirmButtonText || 'Yes',
    icon: this.props.icon || 'trash',
    intent: this.props.intent || 'danger',
  }

  handleOpen = () => this.setState({ isOpen: true });

  handleClose = () => {
    this.setState({ isOpen: false });

    this.props.onModalClosed(this.props.id);
  }

  handleConfirm = async() => {
    await this.props.onConfirm();

    this.handleClose();
  }

  render() {
    return(
      < Alert className={this.state.themeName}
      cancelButtonText={this.state.cancelButtonText}
      confirmButtonText={this.state.confirmButtonText}
      isOpen={true}
      icon={this.state.icon}
      canEscapeKeyCancel={true}
      onCancel={this.handleClose}
      onConfirm={this.handleConfirm}
      intent={this.state.intent}
      ><p>{this.props.message}</p></ Alert>
    );
  }
}

export default AlertModal;
